import isEmpty from 'lodash/isEmpty';

import styles from './styles/common.css';
import { IStyler } from './models';

type TStyle = keyof typeof styles;

const RULES: Array<[keyof IStyler, keyof IStyler]> = [
    ['borderRadius', 'borderRadius'],
    ['marginTop', 'margin'],
    ['marginRight', 'margin'],
    ['marginBottom', 'margin'],
    ['marginLeft', 'margin'],
    ['paddingTop', 'padding'],
    ['paddingRight', 'padding'],
    ['paddingBottom', 'padding'],
    ['paddingLeft', 'padding'],
];

export const generateStyle = (
    styler: IStyler = {},
    injectedClassName?: string
): { className: string } | undefined => {
    const classNames: string[] = [];

    if (isEmpty(styler)) {
        return injectedClassName ? { className: injectedClassName } : undefined;
    }

    for (const [rule, fallback] of RULES) {
        if (styler[rule] !== undefined) {
            classNames.push(styles[`${rule}${styler[rule]}` as TStyle]);
        } else if (styler[fallback] !== undefined) {
            classNames.push(styles[`${rule}${styler[fallback]}` as TStyle]);
        }
    }

    if (injectedClassName) {
        classNames.push(injectedClassName);
    }

    if (classNames.length) return { className: classNames.join(' ') };

    return undefined;
};
